import { isInApp, actBindAliYunPush, actSetUdSpUtil } from '@g/utils/appSDK'
import { getParameterByName } from '@g/utils/index'
import dayjs from 'dayjs'
import { flushReplay } from '@g/utils/sentryInstall'
import { reportEvent } from '@g/utils/aosAnalytics'
import { isMagicbuyProject } from '@g/utils/projectUtils'
import { persistAccessToken } from '@g/utils/authStorage'
import { presentAuthDiagnostic, reportAuthDiagnostic } from '@g/utils/authDiagnostic'

const state = {
}

const getters = {
}

const mutations = {
}

function persistResponseAccessToken (res, rootState, source, { syncUid = false } = {}) {
  if (!res || !res.data || res.data.error) return false

  const model = res.data.model || {}
  if (model.status === 404 && !model.accessToken) return false
  const inApp = isInApp()
  const result = persistAccessToken(model.accessToken, {
    project: rootState.project,
    source,
    inApp,
  })

  if (!result.ok) {
    res.data.error = 'AccessTokenPersistenceFailed'
    res.data.message = `登入失敗（${result.diagnostic.code}），請依畫面提示回報問題`
    res.data.authDiagnosticCode = result.diagnostic.code
    reportAuthDiagnostic(result.diagnostic)
    presentAuthDiagnostic(result.diagnostic)
    return false
  }

  if (inApp) {
    actBindAliYunPush(model.uid)
    actSetUdSpUtil('accessToken', encodeURIComponent(model.accessToken))
    if (syncUid) {
      actSetUdSpUtil('uid', model.uid)
    }
  }
  return true
}

const actions = {
  loginPwd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/login/login-pwd', params)
      .then((res) => {
        persistResponseAccessToken(res, rootState, 'login-pwd', { syncUid: true })
        return res
      })
  },
  signupSendCaptcha ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/user/v1frontend/login/signup-send-captcha', params)
  },
  signup ({ state, commit, rootState }, params) {
    if (params && isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    if (getParameterByName('referrer')) {
      params.signupReferer = getParameterByName('referrer')
    } else {
      params.signupReferer = document.referrer
    }
    return rootState.axios.post('/user/v1frontend/login/signup', {
      ...params,
    }).then((res) => {
      if (persistResponseAccessToken(res, rootState, 'signup')) {
        if (dayjs(res.data.model.createdAt) > (Date.now() - 1000 * 60)) { // 剛注册的用户
          console.log('new user signup', res.data.model.createdAt)
          if (window._ltq) {
            window._lt('send', 'cv', {
              type: 'Register'
            }, ['3dc49dbf-cd3a-45a1-a8ac-52781f6ad91b'])
          }
          // Google Analytics
          // window.gtag && window.gtag('event', 'signup', {
          //   uid: res.data.model.uid,
          // })

          const newUserEvent = window.isPc ? 'pc_new_user' : 'h5_new_user'
          const newUserParams = { uid: res.data.model.uid }
          if (window.gtag) {
            window.gtag('event', newUserEvent, newUserParams)
          } else if (window.dataLayer) {
            window.dataLayer.push({ event: newUserEvent, ...newUserParams })
          }
          reportEvent(window.isPc ? 'pc_new_user' : 'h5_new_user', null, {
            uid: res.data.model.uid,
          })

          flushReplay()
        }
      }
      return res
    })
  },
  resetPassword ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/login/reset-password', params).then((res) => {
      persistResponseAccessToken(res, rootState, 'reset-password')
      return res
    })
  },
  sendResetPasswordCaptcha ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/user/v1frontend/login/send-reset-password-captcha', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
